var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateQrCodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6210_150899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9.16668V9.66668H10.8333H19.1667C19.3508 9.66668 19.5 9.81591 19.4999 9.99992V10C19.4999 10.1841 19.3507 10.3333 19.1666 10.3333H10.8333H10.3333V10.8333V19.1666C10.3333 19.3507 10.1841 19.5 9.99996 19.5C9.81587 19.5 9.66664 19.3507 9.66664 19.1666V10.8333V10.3333H9.16664H0.83332C0.649228 10.3333 0.5 10.1841 0.5 10C0.5 9.81593 0.649207 9.66668 0.83332 9.66664C0.833334 9.66664 0.833349 9.66664 0.833363 9.66664H9.16668H9.66668V9.16664V0.83332C9.66668 0.649228 9.81591 0.5 10 0.5C10.1841 0.5 10.3333 0.649228 10.3333 0.83332V9.16668Z",
    fill: "currentColor",
    stroke: "#DDE1E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6210_150899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateQrCodeIcon);
export default __webpack_public_path__ + "static/media/create-qr-code-icon.1c7ccfe851c6bfc953ce8c149eb846ee.svg";
export { ForwardRef as ReactComponent };